/***
 * Configuration for Interventions Routes
 *
 * Intervention Routes
 * Intervention Type Routes
 * Intervention Report Routes
 ***/

/* ----- Views ----- */

// Intervention
import Interventions from "@/pages/Planning/Intervention/Interventions";
import InterventionAdd from "@/pages/Planning/Intervention/InterventionAdd";
import InterventionDetails from "@/pages/Planning/Intervention/InterventionDetails";

// Intervention Type
import InterventionType from "@/pages/Planning/InterventionType/InterventionType";

// Intervention Report
import InterventionReports from "@/pages/Planning/InterventionReport/InterventionReports";

/* ----- ----- ----- ----- ----- ----- ----- */

// Utils
import { generateParentsList } from "@/router/utils";

const parentsList = {
    interventionsIndex: { label: 'Liste des interventions', name: 'Interventions' },
}

const interventionRoutes = [
    {
        path: 'interventions',
        name: 'Interventions',
        component: Interventions,
        meta: {
            route: {
                label: 'Liste des interventions'
            }
        },
    },
    {
        path: 'interventions/create',
        name: 'Add Intervention',
        component: InterventionAdd,
        meta: {
            route: {
                label: 'Ajout d\'une intervention'
            },
            parents: generateParentsList(parentsList, ['interventionsIndex']),
        },
    },
    {
        path: 'interventions/:id',
        name: 'Intervention Details',
        component: InterventionDetails,
        meta: {
            route: {
                label: 'Détail d\'une intervention',
                shortLabel: 'Intervention #',
                params: { name: 'id', model: 'Planning\\Intervention', column: 'id' },
            },
            parents: generateParentsList(parentsList, ['interventionsIndex']),
        },
    },
]

const interventionTypeRoutes = [
    {
        path: 'intervention_types',
        name: 'InterventionType',
        component: InterventionType,
        meta: {
            route: {
                label: 'Liste des types d\'intervention'
            }
        },
    },
]

const interventionReportRoutes = [
    {
        path: 'intervention_reports',
        name: 'InterventionReports',
        component: InterventionReports,
        meta: {
            route: {
                label: 'Liste des rapports d\'interventions'
            }
        },
    },
]

const routes = [...interventionRoutes, ...interventionTypeRoutes, ...interventionReportRoutes]
export default routes